// Imports for external libraries go here.
import React, { FC, useState } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { StyledContentTabs } from './ContentTabs.styles';
import { ContentTabsType } from './ContentTabs.types';
import { Heading, TabComponent, Types } from '@marriott/mi-ui-library';
import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';
import { EditableComponent } from '@adobe/aem-react-editable-components';

export const ContentTabsConfig = {
  emptyLabel: 'ContentTabs',
  isEmpty: () => false,
  resourceType: `mi-aem-legal-spa/components/content/contenttabs`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TabNavigation: FC<ContentTabsType> = ({ heading, tabDetails }) => {
  const [selectedTab, setSelectedTab] = useState(tabDetails[0].description);

  const onTabSelect = (selectedTabValue: string) => {
    setSelectedTab(selectedTabValue);
  };

  const tabContent = <LegalTextWithLink descriptionText={selectedTab} />;

  //Method returns list of Tabs to be displayed
  const getTabList = () => {
    const tabList = tabDetails?.map(tabItem => ({
      ...tabItem,
      tabTitle: tabItem.subHeading,
      tabSubtitle: '',
      tabValue: tabItem.description,
    }));
    return tabList?.length ? tabList : [];
  };

  const header = () =>
    heading && (
      <Heading
        customClass={'mt-2 mb-2'}
        titleText={heading}
        variation={Types.headingType.title}
        fontSize={Types.size.small}
        element={Types.tags.h3}
      />
    );

  return (
    <StyledContentTabs data-testid="legal-ContentTabs" data-component-name="o-legal-ContentTabs">
      <div className={'tabMenu_header'}>{header()}</div>
      <div className={'tabMenu_content'}>
        <TabComponent
          tabList={getTabList()}
          isSwitcherTabs={true}
          selectedTab={selectedTab}
          setSelectedTab={(selectedTab: string) => {
            onTabSelect(selectedTab);
          }}
        />
        {tabContent}
      </div>
    </StyledContentTabs>
  );
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ContentTabs = (props: any) => {
  return (
    <EditableComponent config={ContentTabsConfig} {...props}>
      <TabNavigation {...props.model} />
    </EditableComponent>
  );
};
